export default __webpack_public_path__ + "files/1f40904aa7bcdbd852202532e3c20a61.svg";